class DetailTitle {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("detailTitle", () => ({
                    share() {
                        if (navigator.share) {
                            navigator
                                .share({
                                    title: "Partager",
                                    text: "Partager l'événement",
                                    url: window.location.href,
                                })
                                .catch((e) => {
                                    if (e.name !== "AbortError") {
                                        this.copyClipboard(
                                            window.location.href,
                                        );
                                    }
                                });
                        } else {
                            this.copyClipboard(window.location.href);
                        }
                    },
                    copyClipboard(text) {
                        navigator.clipboard
                            .writeText(text)
                            .then(
                                () => {
                                    window.useSnackbar.add({
                                        message: "Lien copié.",
                                    });
                                },
                                () => {
                                    window.useSnackbar.add({
                                        type: window.useSnackbar.TYPE_ERROR,
                                        message:
                                            "Nous avons rencontré une erreur lors du partage.",
                                    });
                                },
                            )
                            .catch(() => null);
                    },
                }));
            },
            { once: true },
        );
    }
}

new DetailTitle();
